exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".wy-header {\n  position: absolute;\n  top: 5vw;\n  z-index: 1;\n  text-align: center;\n  width: 100%;\n}\n\n@media (min-width: 992px) {\n  .wy-header {\n    left: 5vw;\n    width: auto;\n    text-align: left;\n  }\n}\n\n.wy-header nav {\n  display: inline-block;\n}\n\n.wy-header nav ul {\n  padding: 0;\n}\n\n.wy-header nav li {\n  display: inline-block;\n  list-style: none;\n  margin-right: 30px;\n}\n\n.wy-header nav li:last-of-type {\n  margin-right: 0;\n}\n\n.wy-header nav li a {\n  color: #00e0a0;\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-size: 1.5em;\n  font-weight: 700;\n  letter-spacing: 3px;\n  text-decoration: none;\n  text-transform: uppercase;\n  transition: color 0.5s cubic-bezier(0.25, 0.1, 0.25, 1);\n}\n\n.wy-header nav li a:hover,\n.wy-header nav li a.wy-active-link {\n  color: #fff;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/resolve-url-loader!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/components/organisms/Header/Header.scss
// module id = 413
// module chunks = 0